import * as store from '@attain-apps/fe/web/main/lib/store'
import * as rxjs from 'rxjs'

import type { Plugin } from '../plugin'

/**
 * Reloads the records list once the responsible persons have been applied.
 */
export const reloadRecordsOnSubmitSuccess = store.effects.create(
  (feature: Plugin['feature'], plugin: Plugin) =>
    feature.actions.submit.success
      .observe()
      .pipe(
        rxjs.map(action =>
          plugin.collection.plugins.currentListPlugin.feature.actions.load
            .from(action)
            .create(),
        ),
      ),
)
